module.exports = __webpack_public_path__ + "media/images/app/how-it-works/sub-icon-mobile-4c1c5f18e2f04608e83304fb8616ab35.webp";